import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, useParams } from "react-router-dom";
import AuthenticationRoutes from "./routes/AuthenticationRoutes";
import UnAuthenticationRoutes from "./routes/UnAuthenticationRoutes";
import { toast, ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import Header from "./container/Header/header";
import FooterText from "./components/FooterText/FooterText";

const App = () => {
  const { email, token } = useSelector(state => state.userState);
  if (true) {
    console.log = function no_console() { };
  }

  useEffect(() => {
    const isFirstLoad = !sessionStorage.getItem("pageVisited");

    if (isFirstLoad) {
      // This is the first visit, set the flag
      sessionStorage.setItem("pageVisited", "true");
    } else {
      // This is a page refresh
      console.log("Page refreshed");
    }
  }, []);
  return (
    <>
      <ToastContainer />
      {email
        &&  token
        ?
        (<Router>
          <Header />
          <FooterText />
          <AuthenticationRoutes /> </Router>)
        :
        (<UnAuthenticationRoutes />)}


    </>
  );
}

export default App;
